import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarScrollWrapper,
  SidebarSpace,
} from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { SidebarLogo } from './SidebarLogo';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { ProductNav } from '../apps/ProductNav';
import { AgentsNavItem } from '../fleet/AgentsNavItem';
import { DocsNavItem } from './DocsNavItem';
import { SearchModalContent } from './SearchModalContent';
import { BackupsNavItem } from '../backups/BackupsNavItem';
import { NotificationsNavItem } from '../notifications/NotificationsNavItem';
import { InboxNavItem } from '../inbox/InboxNavItem';
import { AttributionsNavItem } from '../attributions/AttributionsNavItem';
import { UptimeNavItem } from '../uptime/UptimeNavItem';
import { UserMenuNavItem } from './UserMenuNavItem';

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: ({ navItems }) => {
      const nav = navItems.withComponent(item => (
        <SidebarItem icon={() => item.icon} to={item.href} text={item.title} />
      ));

      // Skipped items
      nav.take('page:search'); // Using search modal instead
      nav.take('page:notifications'); // built-in plugin item; we render NotificationsNavItem (fleet dot) at the bottom
      nav.take('page:app-visualizer'); // linked from the account menu (Visualizer)
      nav.take('page:user-settings'); // linked from the account menu (Manage profile)
      nav.take('page:techdocs'); // replaced by DocsNavItem, below
      nav.take('page:catalog-graph'); // Graph is in the product cluster
      nav.take('page:catalog-import'); // folded into Create (the scaffolder's Register Existing button)
      nav.take('page:catalog'); // Catalog is in the product cluster (out of the Menu group)

      return (
        <Sidebar>
          <SidebarLogo />
          <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
            {/* Custom content so an empty query shows a prompt, not "no results were found". */}
            <SidebarSearchModal>
              {({ toggleModal }) => <SearchModalContent toggleModal={toggleModal} />}
            </SidebarSearchModal>
          </SidebarGroup>
          <SidebarDivider />
          <SidebarGroup label="Menu" icon={<MenuIcon />}>
            {nav.take('page:home')}
            {nav.take('page:scaffolder')}
            <SidebarDivider />
            <SidebarScrollWrapper>
              <ProductNav />
              <UptimeNavItem />
              <AttributionsNavItem />
              <BackupsNavItem />
              <AgentsNavItem />
              <DocsNavItem />
              {nav.rest({ sortBy: 'title' })}
            </SidebarScrollWrapper>
          </SidebarGroup>
          <SidebarSpace />
          <SidebarDivider />
          <NotificationsNavItem />
          <InboxNavItem />
          <SidebarDivider />
          <UserMenuNavItem />
        </Sidebar>
      );
    },
  },
});
